<template>
	
	<div class="content-area__inner content-area__list no-padding has-action-bar">
		
		<el-table v-loading="$store.getters.loading" empty-text="This client has no projects." :data="projects">
			<el-table-column label="Name" :width="320">
				<template slot-scope="scope">
					<div class="project-list__logo">
						<img v-if="scope.row.data.logo_url" :src="scope.row.data.logo_url">
						<ion-icon v-else name="image"></ion-icon>
					</div>
					<div class="project-list__name-container">
						<router-link class="project-list__name" :to="{ name: 'projects/project', params: { projectSlug: scope.row.slug } }">{{ scope.row.name }}</router-link>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="description" label="Description"></el-table-column>
		</el-table>
		
		<el-dialog title="New Project" :visible.sync="newProject.visible" width="30%">
			
			<el-form :model="newProject">
				
				<el-form-item label="Client">
					<el-input v-model="$store.getters.client.name" :disabled="true"></el-input>
				</el-form-item>
				
				<el-form-item label="Project Name">
					<el-input v-model="newProject.name"></el-input>
				</el-form-item>
				
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="onClickNewProjectPopupButton('cancel')">Cancel</el-button>
				<el-button :loading="$store.getters.loading" type="primary" @click="onClickNewProjectPopupButton('confirm')">Save</el-button>
			</span>
			
		</el-dialog>
		
		<ActionBar :actions="actionButtons" @click="onClickActionButton"/>
		
	</div>
	
</template>

<script>
	
	import ActionBar from "@/components/ActionBar.vue";
	
	export default {
		
		components: { ActionBar },
		
		methods: {
			
			onClickNewProjectPopupButton(action) {
				if (action == "confirm") {
					if (!this.newProject.name) {
						this.$message("Please fill in the required fields before adding this project.");
					} else {
						this.$store.commit("setLoading", { type: "start" });
						this.axios.post("projects", {
							client_id: this.$store.getters.client.id,
							name: this.newProject.name,
						}).then((r) => {
							if (r.statusText == "OK") {
								this.newProject.visible = false;
								this.$store.commit("setLoading", { type: "finish", message: "This project has been added." });
								this.$store.dispatch("getApiData", { key: "clients" });
							} else {
								this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while adding this project." });
							}
						}).catch((e) => {
							this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while adding this project." });
						});
					}
				} else if (action == "cancel") {
					this.newProject.visible = false;
				}
			},
			
			onClickActionButton(actionButton) {
				if (actionButton.name == "new") {
					this.newProject.visible = true;
				}
			},
			
			onClickEditProjectButton(data) {
				this.$router.push({ name: "projects/project", params: { projectSlug: data.slug } });
			},
			
		},
		
		computed: {
			
			projects() {
				if (this.$store.getters.client.projects) {
					return this.$store.getters.client.projects.map(function(data, i) {
						return {
							id: data.id,
							name: data.name,
							description: data.description ? data.description : "N/A",
							slug: data.slug,
							data: data,
						};
					});
				}
			},
			
		},
		
		data() {
			
			return {
				
				newProject: {
					visible: false,
					name: "",
				},
				
				actionButtons: [
					{
						name: "new",
						type: "primary",
						icon: "el-icon-plus",
						title: "New Project",
					},
				]
				
			}
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/Projects.vue